import { forkJoin, tap } from 'rxjs';
import { Component, Input, } from '@angular/core';
import { } from '@angular/router';
import { } from '@angular/router';
import { DatePipe, formatDate } from '@angular/common';
import { CodeList, CodeListStatusTypes,Dateformat,CurrencyType, FileExtension,FrequencyValues, TabNames, SubTabNames, ContractTabs, ContractSubTabs, Exportfor, ExportPeriod } from 'src/app/shared/constants/global.constants';
import { FinanceService } from 'src/app/Finance/Services/invoice.service';
import { SponserService } from 'src/app/MasterData/Services/sponser.service';
import { LoaderService } from 'src/app/Loader/loader.service';
import { CurrencyService } from 'src/app/Reusable/currency.service';
import { ConversionRate } from 'src/app/Reusable/conversion-rate';
import FileSaver from 'file-saver';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { ExcelService } from 'src/app/Reusable/excel.service';
import { EngagementService } from 'src/app/Engagement/Services/engagement.service';
import { Privileges } from 'src/app/shared/constants/privileges.constants';
import { environment } from 'src/environments/environment';
import { AuthCommonService } from 'src/app/shared/Authentication/auth.service';
import { DashboardService } from 'src/app/Dashboard/Services/dashboard.service';
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import { EmbeddingContext } from 'amazon-quicksight-embedding-sdk/dist';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { TrustedAdvisor } from 'aws-sdk';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { EngagementFinance, ProjectionsAttachments } from '../Model/engagementSummary';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ContractService } from 'src/app/Contracts/Services/contract.service';
import { AccrualAttachments, AccuralEmailPayload, CodeListValues, ContracDetails, ContractAccrualAttachments } from 'src/app/Finance/Models/contract-accrual';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';
import { UserService } from 'src/app/Admin/Authorization/UserRoleMapping/Services/user.service';
import { ForecastAttachments } from 'src/app/Finance/Models/contract-forecast';
import { FileUploadService } from 'src/app/Engagement/Services/fileupload.service';
import { NotificationService } from 'src/app/shared/Notifications/notification.service';
import { encryptUrlParams } from 'src/app/shared/Urlencoder/url-encoder.util';
import { ExportKpi } from 'src/app/Governance/kpis/Engagement/Model/engagementKpi';

@Component({
  selector: 'app-eng-summary-view',
  templateUrl: './eng-summary-view.component.html',
  styleUrls: ['./eng-summary-view.component.css']
})
export class EngSummaryViewComponent {
  @Input() engagementId:any;
  @Input() engagementName:any;
  engMonthlyProjectionForm: FormGroup;
   forecastForm: FormGroup;
    accrualForm: FormGroup;
  _dateformart :any;
  currenciesData : any[] = [];
  AccumulativeExportData : any[] = [];
  currencyformat:any;
  conversionRate: ConversionRate = new ConversionRate();
  engagementSummarydata:any;
  summaryData:any[]=[];
  engagementSummarydataCopy:any
  totalNoOfContracts:any;
  totalContractedValue:any
  forecastedBillingYTD:any
  actualBillingYTD:any
  paymentYTD:any
  outstandingAmount:any
  selectedCurrency:any;
  selectedAccumulativeExport:any=0;
  selectedAccumulativeExportString:any;
  ExportPrivilage:boolean=false;
  EditProjectionPrivilage :boolean=false;
  engagementFinance = new EngagementFinance();
   fiscalYears: string[] = [];
   fiscalMonths: { name: string, value: string }[] = [];
   isApplyDisable=true;
dashboardId:any;
engagementFiscalYearTableData:any;
defaultCurrency:any;
baseCurruncy:any;
displayMonthlyProjectionDialog:boolean=false;
submitted:boolean=false;

 CategoryData:any[]=[];
 functionsData:any[]=[];
allFunctionsData: any[] = [];
allContracts:any[]=[];
fiscalYearData:any[]=[];
contractName:any;
contractId:number=0;
monthlyProjections: any[] = [];
selectedRowIndex: number | null = null; 
isEditMode:boolean=false;
fisalYears:any;
contractDetailId:any;
isSaveEnabled: boolean = false;
_contractForecastListData:any;
_contractAccrualListData:any;
_originalForecastData:any;
_originalAccrualsData:any;
  codeListValues:any;
  codeListStatusTypes: any;
_contractDetail= new ContracDetails();
  accrualStatusDataSource: CodeListValues[] | undefined;
  
  fiscalYearContractMap: { [fiscalYear: string]: number[] } = {};
  originalForecastListData: any[] = [];
  filteredMonth: any;
  editedMatch: any
  
  displayMonthlyPopup: boolean = false;
  displayDraftPopup: boolean = false;
  forecastDetail: any = {};
  accrualDetail: any = {};

  maxFileSize: any;
  uploadedForecastFileData: any[] = [];
  timeStamp: any;
  formData = new FormData();

  forecastDetailBackup: any;
  accrualDetailBackup: any;
  
  forecastSubmitted: Boolean = false;
  attchement: any
  forecastAttachment: any;
  forecastAttachments: ForecastAttachments[] = [];

  accrualAttachments: AccrualAttachments[] = [];

  fileDetail: any;
  
  deleteForecastFiles: any[] = [];
  deleteAccrualFiles: any[] = [];

  accrualSubmitted: boolean = false;
  isDisabled = false;
  
  accrualAttachment: any;


  uploadedAccrualFileData: any[] = [];
  accrualFormData = new FormData();
  
  currentFileSize: any;
  allowedExtensions: any;
  uploadedFileName: any;

  uploadedProjectionFile: any;
  multiMeetingFileData: any[] = [];
  newAttachment: any;
  _projectionsAttachmentsDetails: ProjectionsAttachments[] = [];
  _projectionAttachments = new ProjectionsAttachments();
  isForecastAttachmentDisabled: boolean = false;
  isAccrualAttachmentDisabled: boolean = false;

  tempEditedRecords: any[] = [];
  selectedRowData: any = null;
  orginalAccrualData: any[] = [];

  myExportForm: FormGroup;
  _export=new ExportKpi();
  exportForOptions = Exportfor;
  submittedExport: boolean = false;
  engagementdata: any;

disablePeriodDropdown = false;
 exportPeriod: any[] = [];
  constructor(
    private _financeInvoiceService:FinanceService,private _masterDataService:SponserService,
    private loaderService: LoaderService,private _currencyService:CurrencyService,
    private privilegeService: PrivilegeService,private datePipe: DatePipe,private excelService: ExcelService,
    private engagementService: EngagementService,private authService: AuthCommonService,private _dashboaredService: DashboardService, private fb: FormBuilder, private messageService: MessageService,  private confirmationService: ConfirmationService, private _contractService: ContractService,private financeService:FinanceService,
    private tabAndStateService: TabAndStateService,private _userService:UserService,private _fileService: FileUploadService,private notificationService:NotificationService) {
  
this.engMonthlyProjectionForm = this.fb.group({
 _categoryId:['', [Validators.required]],
 _functionId: ['', Validators.required],
 _fiscalYear: ['',[Validators.required]],
 _month: ['', Validators.required],
 _contract: ['', Validators.required],
 _monthlyProjection:[null,[Validators.required, Validators.maxLength(15),this.validateNumericField]],
 _fySpend: [''],
 _mrpBudget: [''],
 _ytdActual: [''],
 _contractName: [''],
});

 this.forecastForm = this.fb.group({
      _forecastedAmount: [ '',[Validators.required,Validators.pattern(/^\d{1,13}\.\d{1,2}$|^\d{1,15}$/)]],
      _updatedForecastedAmount : ['', [Validators.pattern(/^\d{1,13}\.\d{1,2}$|^\d{1,15}$/)]],
      _remarks:['', [Validators.maxLength(300)]],
      _forecastFile: [''], 
      _forecastFileName: '',
      _forecastAttachments: [''],
       addProjectionFileSource: [''], addProjectionFileName: '',
    });
  
     this.accrualForm = this.fb.group({
      _accrualAmount: [null, [Validators.required,Validators.pattern(/^\d{1,13}\.\d{1,2}$|^\d{1,15}$/)]],
      _statusMappingId: [null, [Validators.required,this.zeroNotAllowed]],
      _remarks:['', [Validators.maxLength(300)]],
      _accrualFile: [''], 
      _accrualFileName: '',
      _accrualAttachments: [''],
      addAccrualFileSource: [''], addAccrualFileName: '',
    });

     this.myExportForm=this.fb.group({
    _Exportfor:['', [Validators.required]],
    _Period:['',[Validators.required]],
    _Year:['',[Validators.required]]
  });


}
validateNumericField(control: AbstractControl): { [key: string]: any } | null {
  const numericRegex = /^\d+(\.\d{1,2})?$/;
  if (control.value && !numericRegex.test(control.value)) {
    return { invalidNumber: true };
  }
  return null;
}
  onNumericInput(event: Event,_controlname:string) {
  const inputElement = event.target as HTMLInputElement;
  const sanitizedValue = inputElement.value.replace(/\D/g, '');
  inputElement.value = sanitizedValue;
  this.myExportForm.controls[_controlname].setValue(sanitizedValue);
}

zeroNotAllowed(control: AbstractControl) {
  return control.value == 0 ? { required: true } : null;
}
userId:any;
  ngOnInit() {
    this.userId=this.privilegeService.getLoginUserId();
    this.GetUsersList();
     this.codeListValues=CodeList;
    this.codeListStatusTypes=CodeListStatusTypes;
    this._dateformart=Dateformat;
    this.currencyformat=CurrencyType;
    this.GetCurrencyData();
    this.loaderService.hidefinalLoader();
    this.AccumulativeExportData=[
      { Id: 1, Text: 'Invoices'},
      { Id: 2, Text: 'Draft Invoices' },
      { Id: 3, Text: 'Projections'}
  ];
  this.BindEngagementContractsGroups();

  this.GetEngagementFiscalYearDetails();
  this.BindPrivileges();
  this.GetAllContractByEngagementId();
  setTimeout(() => {
    this.GetEngagementDetailsById();
  }, 2000);
 this.GetCategoryCodeList();
    this.engagementFinance.FiscalYear = '';
      this.GetInvoiceStatus(this.codeListValues.Tbl_Status, this.codeListStatusTypes.INVSTS);
   this.getEngagementDetails();
      // Updating Period Values based on Export Selection
       this.exportForOptions = [...Exportfor, { id: 'AllData', name: 'All Data' }];
          this.myExportForm.get('_Exportfor')?.valueChanges.subscribe(value => {
          const exportPeriod = this.myExportForm.get('_Period');
          const exportYear = this.myExportForm.get('_Year');
          exportPeriod?.reset();
          exportYear?.reset();
   
          switch (value) {
            case 'AllData':
              exportPeriod?.disable();
              exportYear?.disable();
              this.exportPeriod = [];
              break;
   
            case 'Quarter':
              this.exportPeriod = ExportPeriod.Quarter;
              exportPeriod?.enable();
              exportYear?.enable();
              break;
   
            case 'HalfYear':
              this.exportPeriod = ExportPeriod.HalfYear;
              exportPeriod?.enable();
              exportYear?.enable();
              break;
   
            case 'Annual':
              this.exportPeriod = [];
              exportPeriod?.disable();
              exportYear?.enable();
              break;
   
            default:
              this.exportPeriod = [];
              exportPeriod?.disable();
              exportYear?.disable();
              break;
          }
        });
   //End Updating Period Values based on Export Selection
  }
    
    getEngagementDetails(){
        this.engagementService.GetEngagementList().subscribe(res => {
          this.engagementdata = res.data.find((t: { id: any; })=>t.id == Number(this.engagementId));
          this.SponsorId=this.engagementdata.sponsorId;
          this.SupplierId=this.engagementdata.supplierId;
        });
    
  
    }
  viewFinanceDashboard=false;
  BindPrivileges(){
 const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
 this.ExportPrivilage = hasPermission(Privileges.ExportEngagementFinance);
 this.viewFinanceDashboard=hasPermission(Privileges.ViewEngagementFinanceDashboard);
 this.EditProjectionPrivilage = hasPermission(Privileges.EditEngagementMonthlyProjections);
 }
    usersList:any;
    GetUsersList(){
    this._userService.GetUserViewDetailsById(this.userId).subscribe((res:any)=>{
      if(res.status){

      this.usersList=res.data.groupId;
      }
    })

    }


  GetConversionRates(){
    this._currencyService.GetConversionRates.subscribe(
      (result:any)=>{
        this.conversionRate=result.data.conversionRates;
        setTimeout(() => {
          this.GetEngagementSummaryDetails(this.engagementId);
        }, 2000);
        
        this.updateTooltipContent();
      }
    );
  }
  GetCurrencyData(){
    this.loaderService.showLoader();
    this._masterDataService.getCodeListData(4,'').subscribe(
      data=>{
      
        this.currenciesData= data.data;

        this.GetConversionRates();
      }
    );
  }
  
  isBaseValue:boolean=false;
  GetEngagementSummaryDetails(engagementId:number){
    this.isBaseValue=false;
    this._financeInvoiceService.GetEngagementSummaryDetailsById(engagementId).subscribe(
      res => {
        if (res.data) {
         
          this.engagementSummarydata = res.data;
          this.engagementSummarydataCopy=res.data;
          this.totalNoOfContracts= this.engagementSummarydata.length;
          if(this.engagementSummarydata.length>0){
          this.isBaseValue=true;
          const currency=this.selectedCurrency.toLowerCase();
          this.ConvertContactValuesByCurrency(currency,this.isBaseValue);
          
          }
          this.loaderService.hideLoader();
        }
      }
    );
  }
  
  ConvertContactValuesByCurrency(currency: any,isBaseValue:boolean) {
    const originalData = [...this.engagementSummarydataCopy];
    this.engagementSummarydata = originalData.map(con => ({ ...con }));
  
    const conversionObservables = this.engagementSummarydata.map((con:any) => {
      if(isBaseValue){
        return this._currencyService.getExchangeRate(this.conversionRate, currency, currency).pipe(
          tap(amount => {
            con.totalContractValue *= amount;
            con.forecastedBillingYTD *= amount;
            con.actualBilledYTD *= amount;
            con.paymentYTD *= amount;
          })
        );
      }
      else{
        con.currencyCode=this.baseCurruncy.toLowerCase();
      return this._currencyService.getExchangeRate(this.conversionRate, con.currencyCode, currency).pipe(
        tap(amount => {
          con.totalContractValue *= amount;
          con.forecastedBillingYTD *= amount;
          con.actualBilledYTD *= amount;
          con.paymentYTD *= amount;
        })
      );
    }
    });

    forkJoin(conversionObservables).subscribe(() => {
      this.updateSummaryValues();
     
    });
  }



  ConvertContactValuesByCurrency_ForFiscalYear(currency: any,isBaseCurrency:boolean) {
    const originalData = [...this.engagementFiscalYearDataOriginal];
    this.engagementFiscalYearData = originalData.map(con => ({ ...con }));
  
    const conversionObservables1=this.engagementFiscalYearData.map((con:any) => {
      if(isBaseCurrency){
      return this._currencyService.getExchangeRate(this.conversionRate, currency, currency).pipe(
        tap(amount1 => {
          con.totalActiveContractBudget *= amount1;
          con.totalActiveContractActualBilled *= amount1;
          con.totalActiveContractBudgetBalance *= amount1;
        })
      );
    }
    else{
      return this._currencyService.getExchangeRate(this.conversionRate, this.baseCurruncy, currency).pipe(
        tap(amount1 => {
          con.totalActiveContractBudget *= amount1;
          con.totalActiveContractActualBilled *= amount1;
          con.totalActiveContractBudgetBalance *= amount1;
        })
      );
    }
    });

    forkJoin(conversionObservables1).subscribe(() => {
  
    });
  }
  
  
  private updateSummaryValues() {
    this.totalContractedValue = this.engagementSummarydata.reduce((t: any, valu: { totalContractValue: any; }) => t + valu.totalContractValue, 0);
    this.forecastedBillingYTD = this.engagementSummarydata.reduce((t: any, valu: { forecastedBillingYTD: any; }) => t + valu.forecastedBillingYTD, 0).toFixed(0);
    this.actualBillingYTD = this.engagementSummarydata.reduce((t: any, valu: { actualBilledYTD: any; }) => t + valu.actualBilledYTD, 0);
    this.paymentYTD = this.engagementSummarydata.reduce((t: any, valu: { paymentYTD: any; }) => t + valu.paymentYTD, 0);
    this.outstandingAmount = (this.actualBillingYTD - this.paymentYTD).toFixed(2);
  }

  getFormattedValue(value: number, currencyName: string): string {
    return this._currencyService.getFormattedValue(value, currencyName);
  }
  getCurrencyType( currencyName: any) {
     return this._currencyService.getCurrencyType(currencyName);
  }
  isChecked:boolean=true;
  checkedInvoice:any[]=[];
  CheckboxEnabled(){
    if(this.checkedInvoice.length>0){
      this.isChecked=false;
    }
    else{
      this.isChecked=true;
    }
  }
  
  selectedRecordsToExpotToExcel: any[] = [];
  exportexcelInvoice() {
  this.selectedRecordsToExpotToExcel = this.checkedInvoice;
  this.selectedRecordsToExpotToExcel = this.selectedRecordsToExpotToExcel.map((invoice) => {
    
    return {
    
      'Contract Id': invoice.contractID,
      Title:invoice.title,
      'Total Contract Value':invoice.totalContractValue,
      'PO Number':invoice.poNumber,
      'Projected Billing':invoice.forecastedBillingYTD,
      'Actual Billed Till Date':invoice.actualBilledYTD,
      'Payment Till Date':invoice.paymentYTD,
      'PO Utilization (%)':invoice.poUtilization
    };
  });
  this.exportExcel(this.selectedRecordsToExpotToExcel,'Engagement Finance',"Finance");
}
  OnCurrencyChange(event:any){
    this.checkedInvoice = [];
    this.CheckboxEnabled();
    this.selectedCurrency=event.value;
   this.ConvertContactValuesByCurrency(event.value,false);
   this.ConvertContactValuesByCurrency_ForFiscalYear(event.value,false);
   this.updateTooltipContent();
  }

exportExcel(SelectedRecords: any, fileName: any, sheetName: string) {
  import('xlsx').then((xlsx) => {
    const worksheet = xlsx.utils.json_to_sheet(SelectedRecords);
    const workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [sheetName] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  });
}
saveAsExcelFile(buffer: any, fileName: string): void {
  let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let EXCEL_EXTENSION = FileExtension.ExportExtention;
  const data: Blob = new Blob([buffer], {
    type: EXCEL_TYPE
  });
  FileSaver.saveAs(data, fileName+ EXCEL_EXTENSION);
}
isSelected:boolean=false;
OnAccumulativeExportChange(event:any){
 this.selectedAccumulativeExport=event.value;
 const selected = this.AccumulativeExportData?.find(x => x.Id === event.value );
 this.selectedAccumulativeExportString = selected ? selected. Text : '';
}
showExportPopUp(){
  this.displayExportPopup=true;
}

_engagementAccumulativeExportData: any[] = [];
GetEngagementAccumulativeExportData(){
  this.loaderService.showLoader();
  this._financeInvoiceService.GetEngagementAccumulativeExportData(this.engagementId,this.selectedAccumulativeExport).subscribe(
    res => {
      if (res.data) {
        this._engagementAccumulativeExportData = res.data;
        const exportFor = this.myExportForm.get('_Exportfor')?.value;
        const period = this.myExportForm.get('_Period')?.value;
        const year = Number(this.myExportForm.get('_Year')?.value);
        this._engagementAccumulativeExportData = this.filterAccumulativeExportData(
          this._engagementAccumulativeExportData,
          exportFor,
          period,
          year,
          this.selectedAccumulativeExport
        );
 
        this.AccumulativeExport(this.selectedAccumulativeExport)
        this.loaderService.hideLoader();
        this.myExportForm.reset();
        this.submittedExport = false;
        this.displayExportPopup = false;
      }
    }
  );
}
 
filterAccumulativeExportData(data: any[], exportFor: any, period: any, year: any, type: any) {
 
  if (exportFor === 'AllData') {
    return data;
  }
 
  const dateField = type === 'Invoice' ? 'invoiceRaisedDate' : 'month';
 
  return data.filter(item => {
 
    const rawDate = item.invoiceRaisedDate || item.month;
    if (!rawDate) return false;
 
    const date = new Date(rawDate);
 
    // Filter by year
    if (year && date.getFullYear() != year) {
      return false;
    }
 
    const month = date.getMonth() + 1;
 
    // Quarter filter
    if (exportFor === 'Quarter' && period) {
 
      const quarterMap: any = {
        Q1: [1,2,3],
        Q2: [4,5,6],
        Q3: [7,8,9],
        Q4: [10,11,12]
      };
 
      return quarterMap[period]?.includes(month);
    }
 
    // HalfYear filter
    if (exportFor === 'HalfYear' && period) {
 
      const halfYearMap: any = {
        H1: [1,2,3,4,5,6],
        H2: [7,8,9,10,11,12]
      };
 
      return halfYearMap[period]?.includes(month);
    }
 
    return true;
 
  });
 
}
AccumulativeExport(exportType:any) {
  if(exportType==1)
    {
    this._engagementAccumulativeExportData = this._engagementAccumulativeExportData.map((invoice) => {
    return {
      'Contract Name': invoice.contractName,
      'Contract ID': invoice.contractId,
      'Function': this.getEngagementGroupNameById(invoice.function),
      'Invoice Number':invoice.invoiceNumber,
      'Invoice Value':invoice.invoiceValue,
      'Invoice Status':invoice.status,
      'Draft Invoice Sent Date':invoice.draftInvoiceSentDate!=null ? this.convertDateFormat(invoice.draftInvoiceSentDate):invoice.draftInvoiceSentDate,
      'Draft Invoice Approval Date':invoice.draftInvoiceApprovalDate!=null ? this.convertDateFormat(invoice.draftInvoiceApprovalDate):invoice.draftInvoiceApprovalDate,
      'Invoice Upload Date':invoice.invoiceRaisedDate!=null ? this.convertDateFormat(invoice.invoiceRaisedDate):invoice.invoiceRaisedDate,
      'Due Date':invoice.dueDate!=null ? this.convertDateFormat(invoice.dueDate):invoice.dueDate,
       'Days To Due Date' : invoice.daysToDueDate,
      'Payment Amount':invoice.paymentAmount,
      'Payment Date':invoice.paymentDate!=null ? this.convertDateFormat(invoice.paymentDate):invoice.paymentDate,
      'Attachment': (invoice.financeContractInvoiceAttachments && invoice.financeContractInvoiceAttachments.length > 0) ? invoice.financeContractInvoiceAttachments[0].fileName : '',
      'Remarks':invoice.remarks,
      'Description':invoice.description,
       'Modified By':this.privilegeService.getUserName(invoice.modifiedBy),
      'Modified Date & Time' : invoice.modifiedBy != null ? (invoice.modifiedDateTime != null ? this.excelService.convertDateTimeFormat(invoice.modifiedDateTime) : '') : '',
    };
  });
  this.exportExcel(this._engagementAccumulativeExportData,this.engagementName+`- InvoicesExport - ${this.convertDateFormat(Date())}`,'InvoicesExportData');
}
if(exportType==2)
  {
  this._engagementAccumulativeExportData = this._engagementAccumulativeExportData.map((accural) => {
  return {
    'Contract Name': accural.contractName,
    'Contract ID': accural.contractId,
    'Function': this.getEngagementGroupNameById(accural.function),
    'Month':this.datePipe.transform(accural.month, "MMMM yyyy"),
    'Draft Invoices Amount':accural.draftInvoicesAmount!=0?accural.draftInvoicesAmount:'',
    'Status':accural.status,
    'Remarks':accural.remarks,
    'Attachments': accural.financeContractAccrualAttachments != null && accural.financeContractAccrualAttachments.length > 0
          ? accural.financeContractAccrualAttachments.map((att: { fileName: any; }) => att.fileName).join(', ') : '',

    'Modified By':this.privilegeService.getUserName(accural.modifiedBy),
    'Modified Date & Time' : accural.modifiedBy != null ? (accural.modifiedDateTime != null ? this.excelService.convertDateTimeFormat(accural.modifiedDateTime) : '') : '',
    'Approved By':this.privilegeService.getUserName(accural.approvedBy),
    'Approved Date & Time':accural.approvedBy != null ? (accural.approvedDateTime != null ? this.excelService.convertDateTimeFormat(accural.approvedDateTime) : '') : '',
  };
});
this.exportExcel(this._engagementAccumulativeExportData,this.engagementName+`- DraftInvoicesExport - ${this.convertDateFormat(Date())}`,'DraftInvoicesExportData');
}
if (exportType == 3) {
const uniqueForecastsWithAmount = (forecasts: any[]) => {
  const foreCastRecords = new Map();
  forecasts.forEach((forecast: { contractName: any; month: string | number | Date; forecastAmount: number; }) => {
    const foreCastMonth = `${forecast.contractName}-${this.datePipe.transform(forecast.month, "MMMM yyyy")}`;
    if (forecast.forecastAmount !== 0) {
      foreCastRecords.set(foreCastMonth, forecast); 
    } else {
      if (!foreCastRecords.has(foreCastMonth)) {
        foreCastRecords.set(foreCastMonth, forecast);
      }
    }
  });
  return Array.from(foreCastRecords.values());
};

this._engagementAccumulativeExportData = uniqueForecastsWithAmount(this._engagementAccumulativeExportData).map((forecast) => { 
  return {
    'Contract Name': forecast.contractName,
    'Contract ID': forecast.contractId,
    'Function': this.getEngagementGroupNameById(forecast.function),
    'Month': this.datePipe.transform(forecast.month, "MMMM yyyy"),
    'Projected Spend': forecast.forecastAmount !== 0 ? forecast.forecastAmount : '',
    'Remarks': forecast.remarks,
    'Attachments': forecast.financeContractForecastAttachments != null && forecast.financeContractForecastAttachments.length > 0
     ? forecast.financeContractForecastAttachments.map((att: { fileName: any; }) => att.fileName).join(', ') : '',
    'Modified By': this.privilegeService.getUserName(forecast.modifiedBy),
    'Modified Date & Time': forecast.modifiedBy !== null ? 
      (forecast.modifiedDateTime !== null ? this.excelService.convertDateTimeFormat(forecast.modifiedDateTime) : '') : '',
  };
});
  this.exportExcel(this._engagementAccumulativeExportData,this.engagementName + `- Monthly Projections Export - ${this.convertDateFormat(Date())}`,'Monthly Projections Export Data');
}

}
convertDateFormat(inputDateTime: string) {
  const date = new Date(inputDateTime);
  const formattedDate = this.datePipe.transform(date, this._dateformart.GridDateFormat);
  return formattedDate;
}
engagementContractsGroups: any;
BindEngagementContractsGroups(){
  this.engagementService.GetAllEngagementContractGroupsById(this.engagementId).subscribe(
    res => {
      if (res.data) {
        this.engagementContractsGroups=res.data;
      }
    }
  );
}
getEngagementGroupNameById(id: number): string | undefined {
  const record = this.engagementContractsGroups.find((item: { id: number; }) => item.id === id);
  return record ? record.engagementGroupName : undefined;
}

engagementFiscalYearData:any;
engagementFiscalYearDataOriginal:any;
GetEngagementFiscalYearDetails(){
  this._financeInvoiceService.GetFiscalYearDataByEngagementId(this.engagementId).subscribe(
    res => {
      if (res.data) {
        this.engagementFiscalYearData=res.data;
        this.engagementFiscalYearDataOriginal=res.data;
      }
});

}

//DashboardCode will start from Here
selectedDashboardToView="";
DashboardToViewDataSource: any[] = [
  { label: 'Till Date Values', value: 'tillDate' },
  { label: 'Fiscal Year Values', value: 'fiscalYear' },
  { label: 'YTD Budget', value: 'ytdBudget' },
  {label:'Product Wise Spend', value: 'productWiseSpend'}
];

IsDashboardTillDate=true;
IsDashboardProductSpend=false;
fiscalYearList:any[]=[];
selectedFiscalYear:any;
onDashboardToViewChange(data:any){
  if(data.value=='tillDate' ){
    this.IsDashboardTillDate=true;
    this.fiscalYearList=[];
    this.fiscalYearList.push({ label: 'Not Applicable', value: 'NotApplicable' });
    this.selectedFiscalYear=this.fiscalYearList[0].value;
    this.isApplyDisable=false;
  }
  else if(data.value == 'productWiseSpend'){
    this.IsDashboardTillDate=false;
    this.IsDashboardProductSpend=true;
    setTimeout(() => {
    this.fiscalYearList=[];
    this.fiscalYearList.push({ label: 'Not Applicable', value: 'NotApplicable' });
      this.selectedFiscalYear=this.fiscalYearList[0].value;
    },1000);
    this.isApplyDisable=false;
    this.GetEngagementFiscalYearTableData();
  }
  else{
    this.IsDashboardTillDate=false;
    this.IsDashboardProductSpend=false;
    this.isApplyDisable=true;
    this.GetEngagementFiscalYearTableData();
  }
}


onFiscalYearChange(data:any){
  if(data.value != null){
  this.isApplyDisable=false;
  }
  else{
    this.isApplyDisable=true;
  }
}

onDashboardApplyClick(){
    if(this.IsDashboardTillDate){
     
      this.dashboardId=environment?._financeEngagementTillDateDashboardId;
    }
    else if (this.selectedDashboardToView == 'ytdBudget') {
      this.dashboardId = environment?._financeEngagementYTDBudgetDashboardId;
    } 
    else if (this.selectedDashboardToView == 'productWiseSpend') {
      this.dashboardId = environment?._financeProductwiseSpendDashboardId;
    } 
    else{
      this.dashboardId=environment?._financeEngagementFiscalYearDashboardId;
    }

    this.GetReportingServicesEmbedURL();
}


GetEngagementFiscalYearTableData(){
  this._financeInvoiceService.GetAllFiscalYearDetailsByEngagementId(this.engagementId).subscribe(
    res => {
      if (res.data) {
        this.engagementFiscalYearTableData=res.data;
        this.GetFiscalYearList();
      }
});
}


GetFiscalYearList(){
  this.fiscalYearList=[];
  const distinctFiscalYears = Array.from(new Set(this.engagementFiscalYearTableData.map((item:any) => item.fiscalYear)));
  
  // Sort the distinct fiscal years in ascending order
  distinctFiscalYears.sort((a:any, b:any) => {
    const [aStartYear, aEndYear] = a.split(' - ').map((part:any) => parseInt(part.split(' ')[1]));
    const [bStartYear, bEndYear] = b.split(' - ').map((part:any) => parseInt(part.split(' ')[1]));

    return aStartYear - bStartYear || aEndYear - bEndYear;
  });
  this.fiscalYearList = distinctFiscalYears.map(fiscalYear => ({
    label: fiscalYear,
    value: fiscalYear
  }));

}

reportingURL:any;
    public async GetReportingServicesEmbedURL() {
      var model = {
        "dashboardID": this.dashboardId,
         "token": this.authService.getCookieValue('LOGIN_TOKEN'),
        "privilege": [
          {
            "MenuName": "string",
            "isAllDataAvailable": true,
            "DataValues": []
          }
        ]
      };
    
    this._dashboaredService.getEmbedUrlData(model).subscribe(
      async (res: any) => {
  
          this.reportingURL=res.data;
          await this.FinanceEngagementDashboard();
    });
     
    }
  
   
    public async FinanceEngagementDashboard() {
      var containerDiv = document.getElementById("DashboardContainer") || '';
      if (containerDiv && containerDiv instanceof HTMLElement) {
        containerDiv.innerHTML = ''; // Clear the container
    }
      const embeddingContext: EmbeddingContext = await createEmbeddingContext();
     let encodedFiscalYear = encodeURIComponent(this.selectedFiscalYear);
      var URL;
      
      if(this.IsDashboardTillDate){
        URL=this.reportingURL + '&#p.EngagementId=' + this.engagementId + '&p.Currency=' + this.baseCurruncy;
      }
      else if(this.selectedDashboardToView=="ytdBudget"){
        URL = this.reportingURL +'&#p.EngagementId=' + this.engagementId + '&p.FiscalYear='+this.selectedFiscalYear;
      }
      else if(this.selectedDashboardToView=="productWiseSpend"){ 
        URL = this.reportingURL +'&#p.EngagementId=' + this.engagementId ;
      }
      else{
        URL=this.reportingURL + '&#p.EngagementId=' + this.engagementId + '&p.FiscalYear=' + encodedFiscalYear + '&p.Currency=' + this.baseCurruncy;
      }
      
      const frameOptions = {
        url: URL,
        container: containerDiv,
        height: "800px",
       // width: "700px",
        resizeHeightOnSizeChangedEvent: true,
        onChange: (changeEvent:any, metadata:any) => {
          switch (changeEvent.eventName) {
            
              case 'FRAME_LOADED': {
                   this.loaderService.hideLoader();
                  break;
              }
          }
      },
    }
      embeddingContext.embedDashboard(frameOptions);
    }
tooltipContent: string = '';
getBaseRate(selectedCurrency: string): number | undefined {
  const lowerCaseCurrency = selectedCurrency.toLowerCase(); // Convert to lowercase
  return this.conversionRate[lowerCaseCurrency as keyof ConversionRate];
}

generateTooltipContent(selectedCurrency: string): string {
  const baseRate = this.getBaseRate(selectedCurrency);
  if (baseRate === undefined) {
    return `Base rate for ${selectedCurrency.toUpperCase()} not found`;
  }

  const availableCurrencyCodes = this.getAvailableCurrencyCodes();
  let content = '';

  for (const [currency, rate] of Object.entries(this.conversionRate)) {
    if (currency.toUpperCase() !== selectedCurrency.toUpperCase() &&
        availableCurrencyCodes.has(currency.toUpperCase()) &&
        rate != null) {
      const convertedRate = this.getConvertedRate(rate, baseRate);
      content += `${selectedCurrency.toUpperCase()} - ${currency.toUpperCase()}: ${isNaN(convertedRate) ? 'N/A' : convertedRate}\n`;
    }
  }
  return content;
}
getConvertedRate(rate: number | undefined, baseRate: number | undefined): number {
  if (rate == null || baseRate == null) {
    return NaN;
  }
  return parseFloat((rate / baseRate).toFixed(4));
}

updateTooltipContent() {
  this.tooltipContent = this.generateTooltipContent(this.selectedCurrency);
} 
getAvailableCurrencyCodes(): Set<string> {
  return new Set(this.currenciesData.map(currency => currency.code.toUpperCase()));
}
GetEngagementDetailsById() {
  this.loaderService.showLoader();  
  if (this.engagementId != undefined && this.engagementId != null) {
    this.engagementService.ViewEngagementById(this.engagementId)
      .subscribe(res => {
        this.loaderService.hideLoader();
       this.defaultCurrency = res.data.defaultCurrency;
       const selectedCurrencyObj = this.currenciesData.find(currency => currency.name === this.defaultCurrency);
       if (selectedCurrencyObj) {
         this.selectedCurrency = selectedCurrencyObj.code;
         this.baseCurruncy=selectedCurrencyObj.code;
         this.ConvertContactValuesByCurrency_ForFiscalYear(this.selectedCurrency.toLowerCase(),true);
       }
     });
}
}
selectedTab: number = 0;
addMonthlyProjections(){
  
    this.isEditMode = false;
   this.engMonthlyProjectionForm.reset();
   this.engagementFinance.Contract = 0;   
   this.engagementFinance.FiscalYear = null; 
     this.engagementFinance.Months = []; 
   this.engagementFinance = new EngagementFinance();
    this.tempEditedRecords = [];
   this.functionsData = [];
   this.monthlyProjections = [];
  this._contractForecastListData = [];
  this._contractAccrualListData=[];
  this._originalAccrualsData=[];
  this._originalForecastData=[];
  this.isSaveEnabled = false;
     this.submitted = false;  
  setTimeout(() => {
      this.displayMonthlyProjectionDialog=true
      this.selectedTab = 0;
      this.isDraftsChanged=false;
      this.isProjecionsChanged=false;
  }, 400);

}

isProjecionsChanged:boolean=false;
isDraftsChanged:boolean=false;
onCancelProjection() {
   this.engagementFinance.Contract = 0;   
   this.engagementFinance.FiscalYear = null; 
if(this.selectedTab==0){
  
const currentData = JSON.stringify(this._contractForecastListData);
const originalData = JSON.stringify(this._originalForecastData);

if (currentData !== originalData && originalData!=undefined) {
  this.isProjecionsChanged=true;
}
else{
  this.isProjecionsChanged=false;
}

}
else if(this.selectedTab==1){
const currentData = JSON.stringify(this._contractAccrualListData);
const originalData = JSON.stringify(this._originalAccrualsData);

if (currentData !== originalData && originalData!=undefined) {
  this.isDraftsChanged=true;
}
else{
  this.isDraftsChanged=false;
}

}
  if (this.isProjecionsChanged || this.isDraftsChanged) {
     let message ='If you cancel, the entered projected amounts will be lost and not saved. Do you want to continue?';

  if (this.isDraftsChanged) {
    message ='If you cancel, the entered Draft Invoice amounts will be lost and not saved. Do you want to continue?';
  }
    this.confirmationService.confirm({
      message: message,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => {
        this.displayDraftPopup=false;
        this.displayMonthlyPopup=false;
        this.resetProjectionForm();
      },
      reject: () => {
      }
    });
  } else {
     this.displayDraftPopup=false;
    this.displayMonthlyPopup=false;
    this.resetProjectionForm();
  }
}

resetProjectionForm() {
  this.engMonthlyProjectionForm.reset();
  this.engagementFinance = new EngagementFinance();
  this.submitted = false;
 this.displayMonthlyProjectionDialog=false;
  this.isEditMode = false;
  this._contractForecastListData = []; 
  this._contractAccrualListData=[];
  this.resetFunction();
}


onClearProjection(){
  this.engMonthlyProjectionForm.reset();
  this.engagementFinance = new EngagementFinance();
   this.submitted = false;
}

 GetCategoryCodeList(){
  this._masterDataService.getCodeListData(21,'').subscribe(
    data=>{
      this.CategoryData=data.data;
    }
  );
}

 GetContractGroupData(id:number,categoyId:number){
      this.engagementService.GetContractByEngagementId(id).subscribe(
        res=>{
            this.allFunctionsData = res.data;
          this.functionsData = this.allFunctionsData.filter(func => func.categoryId === categoyId);
        });
    }
  getCategoryName(id: number): string {
  const category = this.CategoryData.find(c => c.id == id);
  return category ? category.name : '';
}

getFunctionName(id: number): string {
  const func = this.functionsData.find(f => f.id == id);
  return func ? func.name : '';
}
getContractName(id: number): string {
  const contract = this.contractdata.find((c: any) => c.id == id);
  return contract ? contract.title : '';
}

getContractNameMUL(ids: number[]): string {
  return ids
    .map(id => {
      const contract = this.contractdata.find((c: any) => c.id == id);
      return contract ? contract.title : '';
    })
    .filter(x => x !== '')
    .join(', ');
}

getFunctionNameMUL(ids: number[]): string {
  return ids
    .map(id => {
      const func = this.functionsData.find(f => f.id == id);
      return func ? func.name : '';
    })
    .filter(name => name !== '')
    .join(', ');
}

getCategoryNameMUL(ids: number[]): string {
  return ids
    .map(id => {
      const category = this.CategoryData.find(c => c.id == id);
      return category ? category.name : '';
    })
    .filter(name => name !== '')
    .join(', ');
}

onDeleteProjection(rowData: any) {
  const index = this.monthlyProjections.indexOf(rowData);
  if (index !== -1) {
    this.monthlyProjections.splice(index, 1);
  }
}

showWarningMessage(summary: string) {
  this.messageService.add({
    key: 'tc',
    severity: 'warn',
    summary: summary,
    detail: '',
  });
}

contractdata:any;
originalContractData:any;
    GetAllContractByEngagementId(){
      this._contractService.GetAllContractByEngagementId(this.engagementId).subscribe(
        res => {
          this.originalContractData = [...res.data];
          this.currencyId=res.data[0].currencyId
        });
    }


  GetContractData(value:any){
    this._financeInvoiceService.GetAllContractsByEngagementId(this.engagementId).subscribe(res => {
    if (res?.data?.length) {
      this.allContracts = res.data;
      const matchedContract = this.allContracts.find(contract => contract.id == value);

      if (matchedContract) {
        this.contractId=matchedContract.id;
        this.contractName=matchedContract.title;

      } 
    }
  });
  }

onForecastAmountChange() {
 this.isSaveEnabled = this._contractForecastListData.some((item: { forecastedAmount: null | undefined; }) =>
    item.forecastedAmount != null && item.forecastedAmount != undefined);
}


 getDatesFromFiscalYear(fiscalYear: string): [string, string] {
  const [startStr, endStr] = fiscalYear.split(' - '); 
  const startDate = new Date(startStr + ' 01'); 
  const endDate = new Date(endStr + ' 01');     

  const format = (date: Date) =>
    ('0' + (date.getMonth() + 1)).slice(-2) + '/' + '01' + '/' + date.getFullYear();
  return [format(startDate), format(endDate)];
}


originalAccrualstListData:any;

  getContractForecastByContractIds(contractModels: any[]) {
  

  if (!contractModels || contractModels.length == 0) {
    return;
  }

  if (this.selectedTab == 0) {
    this.financeService.GetContractForecastByContractIds(contractModels).subscribe(response => {
         const data = response.data || [];

        data.forEach((row: { contractDetailId: any; contractName: any; }) => {
          const contract = this.contractdata.find((c: { id: any; }) => c.id == row.contractDetailId);
          row.contractName = contract ? contract.title : '--';
        });
        this.originalForecastListData = data;
        this.bindMonthData();
      });
  } 
  else if (this.selectedTab == 1) {

    this.financeService.GetContractAccrualByContractIds(contractModels).subscribe(response => {
         const data = response.data || [];

        data.forEach((row: { contractDetailId: any; contractName: any; }) => {
          const contract = this.contractdata.find((c: { id: any; }) => c.id == row.contractDetailId);
          row.contractName = contract ? contract.title : '--';
        });

        this.originalAccrualstListData = data;
        this.bindMonthData();
      });
  
  }
}

getContractForecastByContractIdMUL(contractDetail: any) {
  const fiscalYear = this.engagementFinance.FiscalYears;
  if (!fiscalYear || !fiscalYear.includes(' - ')) {
    this._contractForecastListData = [];
    this._contractAccrualListData = [];
    return;
  }
       
  const [startMonthYear, endMonthYear] = fiscalYear.split(' - '); 
  const fiscalStartDate = new Date(startMonthYear + ' 01'); 
  const fiscalEndDate = new Date(new Date(endMonthYear + ' 01').getFullYear(), 2, 31); 

   if(this.selectedTab==0){
  this.financeService.GetContractForecastByContractId(contractDetail).subscribe(response => {
    if (response.data) {
        const filteredData = response.data.filter((item: any) => {
        const forecastDate = new Date(item.forecastDate);
        return forecastDate >= fiscalStartDate && forecastDate <= fiscalEndDate;
      });
      this._contractForecastListData = filteredData.map((item: any) => ({
         ...item,
        contractDetailId: this.contractDetailId,
        category: this.engagementFinance.CategoryIds ? this.getCategoryNameMUL(this.engagementFinance.CategoryIds) : '',
        function: this.engagementFinance.FunctionIds ? this.getFunctionNameMUL(this.engagementFinance.FunctionIds) : '',
        contractName: this.engagementFinance.Contracts ? this.getContractNameMUL(this.engagementFinance.Contracts) : '',
        fiscalYear: fiscalYear,
        isEditable: true,
        mrpSpend: this.engagementFinance.MRPSpend,
        actualFY: this.engagementFinance.ActualFY,
      }));
      this._originalForecastData = JSON.parse(JSON.stringify(this._contractForecastListData));
      this.originalForecastListData = [...this._contractForecastListData];
      this.bindMonthData();
    }
  });
}
     if(this.selectedTab==1){
   this.financeService.GetContractAccrualByContractId(contractDetail).subscribe(response => {
    if (response.data) {
        const filteredData = response.data.filter((item: any) => {
        const accrualDate = new Date(item.accrualDate);
        return accrualDate >= fiscalStartDate && accrualDate <= fiscalEndDate;
      });
      
      this._contractAccrualListData = filteredData.map((item: any) => ({
         ...item,
        contractDetailId: this.contractDetailId,
        category: this.engagementFinance.CategoryIds ? this.getCategoryNameMUL(this.engagementFinance.CategoryIds) : '',
        function: this.engagementFinance.FunctionIds ? this.getFunctionNameMUL(this.engagementFinance.FunctionIds) : '',
        contractName: this.engagementFinance.Contracts ? this.getContractNameMUL(this.engagementFinance.Contracts) : '',
        fiscalYear: fiscalYear,
        isEditable: true,
        mrpSpend: this.engagementFinance.MRPSpend,
        actualFY: this.engagementFinance.ActualFY,
      }));
      this._originalAccrualsData = JSON.parse(JSON.stringify(this._contractAccrualListData));
      this._originalAccrualsData = [...this._contractAccrualListData];
      this.bindMonthData();
      this.orginalAccrualData = JSON.parse(JSON.stringify(this._contractAccrualListData));
    }
  });
}
  

}

effectiveStartDate: string = '';
effectiveEndDate: string = '';


 oldFiscalYearData:any;
  GetFiscalYearDataByContract(){
  
    this._financeInvoiceService.GetFiscalYearDataByContractId(this.contractId).subscribe(
      res => {
        if (res.data) {
          this.oldFiscalYearData=res.data;
          this.GetAllInvoicesByContractId();
        }
      }
    );
  }

invoiceData:any;
  filteredInvoicesData:any;
  GetAllInvoicesByContractId(){
    this._financeInvoiceService.GetFinanceInvoiceId(this.contractId).subscribe(
      res => {
        if (res.data) {
          this.invoiceData = res.data;

          //filter by status(need only paid and Raised)
          this.filteredInvoicesData = this.invoiceData.filter((invoice: any) => 
            this.invoiceStatusData.some((status: any) => 
              status.id === invoice.statusMappingId && (status.name === "Raised" || status.name === "Paid")
            )
          );

          this.processInvoices(this.oldFiscalYearData,this.filteredInvoicesData);             
            
        }
      }
    );
  }

   processInvoices(FiscalYearData: any, filteredInvoicesData: any): any {
    FiscalYearData.forEach((fiscalYear:any) => {
      // Parse the financial year
      const dates = fiscalYear.fiscalYear.split(' - ');
      const startDate = this.parseDate(dates[0]);
      const endDate = this.parseDate(dates[1]);

      // Adjust end date to include the whole month of March
      //const adjustedEndDate = new Date(endDate);
      const adjustedEndDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0); 

      adjustedEndDate.setHours(23, 59, 59, 999);

      // Calculate the sum of InvoiceValue where RaisedDate is within the financial year
      const totalInvoiceValue = this.filteredInvoicesData
      .filter((fi: any) => {
        const raisedDate = this.parseDate(fi.invoiceRaisedDate);
        return raisedDate >= startDate && raisedDate <= adjustedEndDate;
      })
      .reduce((sum: number, fi: any) => sum + fi.invoiceValue, 0);

      // Update the ActualBilled columns
      fiscalYear.actualBilledFY = totalInvoiceValue;

      if(fiscalYear.budgetFY != null && fiscalYear.budgetFY != undefined)
      fiscalYear.budgetBalanceFY=fiscalYear.budgetFY-fiscalYear.actualBilledFY;
    else
    fiscalYear.budgetBalanceFY=0-fiscalYear.actualBilledFY;

    if(fiscalYear.budgetFY==null && fiscalYear.actualBilledFY == 0){
      fiscalYear.budgetBalanceFY=null;
    }
    });
    
      const matchedFY = FiscalYearData?.find((item: any) => item.fiscalYear == this.engagementFinance.FiscalYear);
      if(matchedFY!=undefined && matchedFY !=null && matchedFY ){
      this.engagementFinance.ActualFY = matchedFY ? matchedFY.actualBilledFY : 0;
      }
      else{
        this.engagementFinance.ActualFY=0;
      }
  }
  
    parseDate(dateString: string): Date {
    return new Date(dateString);
  }
    invoiceStatusData:any;
  GetInvoiceStatus(enumId: number, type: string) { 

    this._masterDataService.getCodeListData(enumId, type).subscribe(
      res => {
        if (res.data.length > 0) {
          this.invoiceStatusData = res.data;
            
        }
      }
    );
  }

  onCategoryChange(selectedCategories: number[]) {
    this.resetFunction();
    this.engMonthlyProjectionForm.get('_categoryId')?.setValue(selectedCategories);

    this.engMonthlyProjectionForm.get('_functionId')?.setValue([]);
    this.engMonthlyProjectionForm.get('_contract')?.setValue([]);
    this.engMonthlyProjectionForm.get('_fiscalYear')?.setValue(null);

    this.engagementFinance.FunctionIds = [];
    this.engagementFinance.Contracts = [];
    this.engagementFinance.FiscalYear = null;
    this.engagementFinance.MRPSpend = '';
    this.engagementFinance.ActualFY = '';

    this.GetContractGroupData_Mul(this.engagementId, selectedCategories);
  }
  GetContractGroupData_Mul(engagementId: number, selectedCategoryIds: number[]) {
    
    this.engagementService.GetContractByEngagementId(engagementId).subscribe(res => {
      this.allFunctionsData = res.data;
      this.functionsData = this.allFunctionsData.filter(func =>
        selectedCategoryIds.includes(func.categoryId)
      );
    });
  }

  getMRPDetails(event: number[]) {
    this.resetContract();
    this.engMonthlyProjectionForm.get('_functionId')?.setValue(event);
    this.engMonthlyProjectionForm.get('_contract')?.setValue('');
    this.engMonthlyProjectionForm.get('_fiscalYear')?.setValue('');

    this.engagementFinance.Contracts = [];
    this.engagementFinance.FiscalYear = '';
    this.engagementFinance.MRPSpend = '';
    this.engagementFinance.ActualFY = '';
    this._contractForecastListData = [];
    this._contractAccrualListData = [];

    if (this.originalContractData && Array.isArray(this.originalContractData)) {
      this.contractdata = this.originalContractData.filter(
        (contract: any) => event.includes(contract.ownerFunctionId)
      );
    }

    if (this.engMonthlyProjectionForm.valid) {
      this.checkAndLoadProjectionData();
    }
  }


  checkAndLoadProjectionData(): void {
    
    const { CategoryIds, FunctionIds, Contracts, FiscalYears } = this.engagementFinance;
    const allSelected = CategoryIds?.length && FunctionIds?.length && Contracts?.length && FiscalYears;

    if (allSelected && this.effectiveStartDate && this.effectiveEndDate) {
      this.getContractForecastByContractIdMUL({
        contractDetailIds: Contracts,
        contractStartDate: this.effectiveStartDate,
        contractEndDate: this.effectiveEndDate
      });
    } else {
      this._contractForecastListData = [];
      this._contractAccrualListData = [];
    }
  }
  contractInfo: any;

  GetContractDetailsByContractId(contractIds: number[] | null | undefined) {
    
    this.resetMonth();
    if (!contractIds || contractIds.length === 0) {
      return;
    }

    this.loaderService.showLoader();

    this._contractService.GetContractDetailsByContractIds(contractIds).subscribe(res => {
      this.loaderService.hideLoader();
      if (res?.data && res.data.length > 0) {
        this.contractInfo = res.data;
        this.buildContractMap();
        const contractDetail: any[] = [];
        this.contractInfo.forEach((contract: any) => {
          contractDetail.push({
            contractDetailId: contract.id,
            contractStartDate: this.datePipe.transform(contract.startDate, 'MM/dd/yyyy'),
            contractEndDate: this.datePipe.transform(contract.endDate, 'MM/dd/yyyy')
          });
        });

        this.getContractForecastByContractIds(contractDetail);
      }
    },
      error => {
        this.loaderService.hideLoader();
      });
  }



  GetFiscalYearDataByContractId(contractIds: number[]) {
    this.resetFiscalYear();
    this.contractFunctionMap.clear();

    this.contractCategoryMap.clear();
    contractIds.forEach((contractId: number, index: number) => {
      const contract = this.contractdata.find((t: { id: number; }) => t.id === contractId);
      const functionId = contract ? contract.ownerFunctionId : null;
       const func = this.functionsData.find(f => f.id === functionId);
    if (func) {
      this.contractCategoryMap.set(contractId, func.categoryId);
    }


      if (functionId !== undefined && functionId !== null) {
        this.contractFunctionMap.set(contractId, functionId);
      }
    });

    if (!contractIds || contractIds.length === 0) {
      this.fiscalYears = [];
      return;
    }

    this.engMonthlyProjectionForm.get('_contract')?.setValue(contractIds);
    this.engMonthlyProjectionForm.get('_fiscalYear')?.reset();
    this.engagementFinance.FiscalYears = null;
    this.engagementFinance.MRPSpend = '';
    this.engagementFinance.ActualFY = '';

    this._contractForecastListData = [];
    this._contractAccrualListData = [];

    this._financeInvoiceService
      .GetFiscalYearDataByContractIds(contractIds)
      .subscribe(res => {
        if (res?.data?.length > 0) {
          this.fiscalYearContractMap = {};
          const uniqueFY = new Map<string, any>();

          res.data.forEach((item: any) => {
            const match = item.fiscalYear.match(/(\d{4})\s*-\s*(\d{4})/);
            const label = match ? `${match[1]}-${match[2].slice(-2)}` : item.fiscalYear;

            if (!uniqueFY.has(label)) {
              uniqueFY.set(label, { label, value: label });
            }

            if (!this.fiscalYearContractMap[label]) {
              this.fiscalYearContractMap[label] = [];
            }
            this.fiscalYearContractMap[label].push(item.contractDetailId);
          });

          this.fiscalYears = Array.from(uniqueFY.values());
        }
      });

    setTimeout(() => {
      this.checkAndLoadProjectionData();
    }, 500);
  }


  getMonthNameFromDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      const [month] = dateString.split('/');
      const monthIndex = Number(month) - 1;
      return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][monthIndex] || '';
    }

    return date.toLocaleString('en-US', { month: 'long' });
  }
  monthDropdownData: any[] = [];
  bindMonthData() {
    const uniqueMonths = new Set<string>();
     if (this.selectedTab == 0) {
      this.originalForecastListData.forEach((item: { forecastDate: string; }) => {
        const month = this.getMonthNameFromDate(item.forecastDate);

        if (month) uniqueMonths.add(month);
      });
    }
    else if (this.selectedTab == 1) {
      this.originalAccrualstListData.forEach((item: { accrualDate: string; }) => {
        const month = this.getMonthNameFromDate(item.accrualDate);

        if (month) uniqueMonths.add(month);
      });
    }

    this.monthDropdownData = Array.from(uniqueMonths).map(m => ({
      label: m,
      value: m
    }));
    this.loaderService.hideLoader();
  }

  contractFunctionMap = new Map<number, number>();
  contractCategoryMap = new Map<number, number>();

  onMonthChange() {
    const selectedMonths = this.engagementFinance.Months;
    const fiscalYearStr = this.engagementFinance.FiscalYears;

    if (!selectedMonths || selectedMonths.length === 0) {
      this._contractForecastListData = [];
      this._contractAccrualListData = [];
      return;
    }
    if (!fiscalYearStr || !fiscalYearStr.includes(" - ")) {
      this._contractForecastListData = [];
      this._contractAccrualListData = [];
      return;
    }

    const [startStr, endStr] = fiscalYearStr.split(" - ");
    const startYear = Number(startStr.split(" ")[1]); // 2025
    const endYear = Number(endStr.split(" ")[1]);     // 2026

    const fiscalStartDate = new Date(`April ${startYear} 01`);
    const fiscalEndDate = new Date(`March ${endYear} 31`);

     if (this.selectedTab == 0) {
      this.filteredMonth = this.originalForecastListData.filter(item => {
        const date = new Date(item.forecastDate);

        const monthName = date.toLocaleString('en-US', { month: 'long' });

        return (
          selectedMonths.includes(monthName) &&
          date >= fiscalStartDate &&
          date <= fiscalEndDate
        );
      });
    }
     if (this.selectedTab == 1) {
      this.filteredMonth = this.originalAccrualstListData.filter((item: { accrualDate: string | number | Date; }) => {
        const date = new Date(item.accrualDate);

        const monthName = date.toLocaleString('en-US', { month: 'long' });
        
        return (
          selectedMonths.includes(monthName) &&
          date >= fiscalStartDate &&
          date <= fiscalEndDate
        );
      });
    }

    this.filteredMonth = this.filteredMonth.map((item: any) => {
      const functionId = this.contractFunctionMap.get(item.contractDetailId);
       const categoryId = this.contractCategoryMap.get(item.contractDetailId);
       

      const mappedItem = {
        ...item,
        category: categoryId ? this.getCategoryName(categoryId) : '--',
        function: functionId !== undefined ? this.getFunctionName(functionId) : '--'

      };

      if (this.selectedTab == 0) {
        this.editedMatch = this.tempEditedRecords.find(x =>
          x.forecastDate === mappedItem.forecastDate &&
          x.contractName === mappedItem.contractName &&
          x.function === mappedItem.function &&
          x.category === mappedItem.category
        );
      }
      if (this.selectedTab == 1) {
        this.editedMatch = this.tempEditedRecords.find(x =>
          x.accrualDate === mappedItem.accrualDate &&
          x.contractName === mappedItem.contractName &&
          x.function === mappedItem.function &&
          x.category === mappedItem.category
        );
      }


      return this.editedMatch ? { ...mappedItem, ...this.editedMatch } : mappedItem;
    });

     if (this.selectedTab == 1) {
         this._contractAccrualListData = this.filteredMonth;
          this._originalAccrualsData = JSON.parse(JSON.stringify(this._contractAccrualListData));
    }
    if (this.selectedTab == 0) {
      this._contractForecastListData = this.filteredMonth;
      this._originalForecastData = JSON.parse(JSON.stringify(this._contractForecastListData));
    }
  }


  contractMap = new Map<number, string>();
  buildContractMap() {
    
    this.contractMap.clear();
    this.contractdata.forEach((c: { id: number; title: string; }) => {
      this.contractMap.set(c.id, c.title);
    });
  }



  onCancelEdiProjction() {
    if (this.selectedTab == 0) {
      this.forecastDetail = JSON.parse(
        JSON.stringify(this.forecastDetailBackup)
      );

      this.displayMonthlyPopup = false;
      this.displayMonthlyProjectionDialog = true;
    }
    if (this.selectedTab == 1) {
      this.accrualDetail = JSON.parse(
        JSON.stringify(this.accrualDetailBackup)
      );

      this.displayMonthlyPopup = false;
      this.displayMonthlyProjectionDialog = true;
    }
  }

  onEditRow(rowData: any) {
    const orginalData = JSON.parse(JSON.stringify(rowData));
    if (this.selectedTab == 0) {
      this.forecastSubmitted = false;
       this.forecastDetailBackup = JSON.parse(JSON.stringify(rowData));
    this.forecastAttachments = rowData.financeContractForecastAttachments?.length > 0 ? [...rowData.financeContractForecastAttachments] : [];

    this.uploadedForecastFileData = [];
    this.uploadedFiles = this.forecastAttachments.map((att: any) => {
      const file = new File([new Blob([''])], att.fileName || att.name);
      (file as any).filePath = att.filePath || att.path; 
      return file;
    });

    this.isUploadButtonDisabled = this.uploadedFiles.length >= 3;
    
      this.uploadedForecastFileData = [];
      this.isForecastAttachmentDisabled = this.forecastAttachments.length >= 3;
      orginalData.originalProjectedAmount = orginalData.originalProjectedAmount ?? orginalData.forecastedAmount;
      const matchedContract = this.contractdata.find(
        (x: any) => x.title?.trim() === orginalData.contractName?.trim()
      );

      if (matchedContract) {
        orginalData.contractDetailId = matchedContract.id;
      }

      this.forecastDetail = orginalData;

      this.forecastAttachments = orginalData.financeContractForecastAttachments?.length > 0 ? [...orginalData.financeContractForecastAttachments] : [];
      this.displayMonthlyPopup = true;
      this.displayMonthlyProjectionDialog = false;
    }

    if (this.selectedTab == 1) {
      this.accrualSubmitted = false;
      this.GetAccrualStatus(3);
        const orginalData = JSON.parse(JSON.stringify(rowData));
      this.accrualDetailBackup = JSON.parse(JSON.stringify(rowData));

   this.accrualAttachments = rowData.financeContractAccrualAttachments?.length > 0 ? [...rowData.financeContractAccrualAttachments] : [];
    this.uploadedAccrualFileData = [];
    this.uploadedAccrualFiles = this.accrualAttachments.map((att: any) => {
      const file = new File([new Blob([''])], att.fileName || att.name);
      (file as any).filePath = att.filePath || att.path; 
      return file;
    });

      this.uploadedAccrualFileData = [];
       this.isUploadButtonDisabled = this.uploadedAccrualFiles.length >= 3;
      this.isAccrualAttachmentDisabled = this.accrualAttachments.length >= 3;

      const matchedContract = this.contractdata.find((x: any) => x.title?.trim() === orginalData.contractName?.trim());

      if (matchedContract) {
        orginalData.contractDetailId = matchedContract.id;  
      }

      this.accrualDetail = orginalData;

      this.accrualAttachments = orginalData.financeContractAccrualAttachments?.length > 0 ? [...orginalData.financeContractAccrualAttachments] : [];
      const accrualData = this.originalAccrualstListData.find((t: any) => new Date(t.accrualDate).getTime() === new Date(orginalData.accrualDate).getTime());

      const status = accrualData?.accrualStatus ?? null;


      if (status == 'Approved') {
        this.isDisabled = true;
      }
      else {
        this.isDisabled = false;
      }

      this.displayDraftPopup = true;
      this.displayMonthlyProjectionDialog = false;
    }

  }


  GetAccrualStatus(type: number) {
    this._masterDataService.getCodeListData(type, 'Accrual Status').subscribe(
      res => {
        this.accrualStatusDataSource = res.data;
           var status= this.accrualStatusDataSource?.find(data=>data.id==this.accrualDetail.statusMappingId)?.name;
        if(status=='Approved'){
              this.isDisabled=true;
          }
          else{
              this.isDisabled=false;
          }
      }
    );
  };
  onStatusChange(event: any) {
    var status = this.accrualStatusDataSource?.find(data => data.id == event.value)?.name;

    if (status == 'Approved') {
      this.accrualDetail.approvedBy = this.privilegeService.getLoginUserId();;
      this.accrualDetail.approvedDateTime = new Date();
    }
    else {
      this.accrualDetail.approvedBy = null;
      this.accrualDetail.approvedDateTime = null;
    }

  }

  getTooltip(att: any): string {
    const name = att?.fileName ?? '';
    return name.length > 40 ? name : '';
  }


  onSaveEditedProjection() {

    const edited = {
      ...this.forecastDetail,
      financeContractForecastAttachments: [...this.forecastAttachments],
      uploadedFiles: [...this.uploadedForecastFileData],
      updatedBy : this.userId

    };

    const matchFn = (x: any) =>
      x.forecastDate === edited.forecastDate &&
      x.contractName === edited.contractName &&
      x.function === edited.function &&
      x.category === edited.category

    const tempIndex = this.tempEditedRecords.findIndex(matchFn);

    if (tempIndex !== -1) {
      this.tempEditedRecords[tempIndex] = edited;
    } else {
      this.tempEditedRecords.push(edited);
    }

    const tableIndex = this._contractForecastListData.findIndex(matchFn);

    if (tableIndex !== -1) {
      this._contractForecastListData[tableIndex] = { ...edited };
      this._contractForecastListData[tableIndex] = {
        ...this._contractForecastListData[tableIndex],
        ...edited,
        financeContractForecastAttachments: [...this.forecastAttachments]
      };
    }
    this.displayMonthlyPopup = false;

    this.isSaveEnabled = true;
    this.displayMonthlyProjectionDialog = true;
  }

  onSaveEditedAccruals() {
    this.accrualSubmitted = true;
    if (this.accrualForm.valid) {

      const statusName = this.getAccrualStatusName(this.accrualDetail.statusMappingId);
      const edited = {
        ...this.accrualDetail,
        accrualStatus: statusName,
        financeContractAccrualAttachments: [...this.accrualAttachments],
        uploadedAccrualFiles: [...this.uploadedAccrualFileData],
        updatedBy : this.userId
      };

      const matchFn = (x: any) =>
        x.accrualDate === edited.accrualDate &&
        x.contractName === edited.contractName &&
        x.function === edited.function &&
        x.category === edited.category

      const tempIndex = this.tempEditedRecords.findIndex(matchFn);

      if (tempIndex !== -1) {
        this.tempEditedRecords[tempIndex] = edited;
      } else {
        this.tempEditedRecords.push(edited);
      }

      const tableIndex = this._contractAccrualListData.findIndex(matchFn);

      if (tableIndex !== -1) {
        this._contractAccrualListData[tableIndex] = { ...edited };

        this._contractAccrualListData[tableIndex] = {
          ...this._contractAccrualListData[tableIndex],
          ...edited,
          financeContractAccrualAttachments: [...this.accrualAttachments]
        };
      }
      this.displayDraftPopup = false;
      this.isSaveEnabled = true;
      this.displayMonthlyProjectionDialog = true;
    }
    else {
      this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Please enter required information', detail: '' });
    }
  }


  private getAccrualStatusName(statusId: number | null | undefined): string {
    if (!statusId) {
      return '';
    }
    const status = this.accrualStatusDataSource ?.find((x: any) => x.id === statusId);
    return status?.name ?? '';
  }


  async saveContractForecast() {
    if (!this.tempEditedRecords || this.tempEditedRecords.length === 0) {
      this.messageService.add({
        key: 'tc',
        severity: 'warn',
        summary: 'No changes to save',
        detail: ''
      });
      return;
    }

    if (this.selectedTab == 0) {
      this.loaderService.showLoader();

      try {

        for (const record of this.tempEditedRecords) {

          this.forecastDetail = record;

          if (this.deleteUploadedFiles.length > 0 ) {
            this.deleteForecastAttachment();
          }
          if (this.multiForecastFileData.length > 0) {
            this.loaderService.showLoader();
            this._fileService.UploadMultipleFile(this.formData).subscribe((response: any) => {
              if (response) {
                this.updateForecastDetails(record);
              }
              else {
                this.loaderService.hideLoader();
                this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Add Forecast File Failed to save', detail: '' });
              }
            })
          }
          else {
            this.updateForecastDetails(record);
          }
        }

        this.tempEditedRecords = [];
        this.displayMonthlyProjectionDialog = false;

        setTimeout(() => {
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'Changes have been saved',
            detail: ''
          });
        }, 2000);

      } catch (err) {

        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'One or more records failed to save',
          detail: ''
        });

      } finally {
      }
    }
    else if (this.selectedTab == 1) {
      this.loaderService.showLoader();
      try {
        for (const record of this.tempEditedRecords) {
          this.accrualDetail = record;

          if (this.deleteUploadedFiles.length > 0 ) {
            this.deleteAccrualsAttachment();
          }
          if (this.multiAccrualFileData.length > 0) {
            this.loaderService.showLoader();
            this._fileService.UploadMultipleFile(this.formData).subscribe((response: any) => {
              if (response) {
                this.updateAccrualDetailsBulk(record);
              }
              else {
                this.loaderService.hideLoader();
                this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Add Accrual File Failed to save', detail: '' });
              }
            })
          }
          else {
            this.updateAccrualDetailsBulk(record);
          }
        }

        this.tempEditedRecords = [];
        this.displayMonthlyProjectionDialog = false;
        setTimeout(() => {
          this.messageService.add({
          key: 'tc',
          severity: 'success',
          summary: 'Changes have been saved',
          detail: ''
        });
        }, 2000);
      } catch (err) {

        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'One or more records failed to save',
          detail: ''
        });

      } finally {
      }
    }
  }

  updateForecastDetails(record: any): Promise<any> {
    return new Promise((resolve, reject) => {

      const payload = {
        ...record,
        forecastDate: this.datePipe.transform(record.forecastDate, "MM/dd/yyyy"),
        createdBy: this.privilegeService.getLoginUserId(),

      };

      this.financeService.UpdateContractForecast(payload).subscribe(res => {

        if (res.status) {
          this.loaderService.hideLoader();
          resolve(res);
        } else {
          this.loaderService.hideLoader();
          reject(res);
        }

      }, err => reject(err));
    });
  }
oldStatus:any;
oldAmout:any;
isStatusApproved:boolean=false;
isDataUpdate:boolean=false;
_TabId:any;
_SubTabId:any;
_accuralEmailPayload=new AccuralEmailPayload();
  currency:any;
  SupplierId: any;
  SponsorId: any;
  currencyId:any;

async updateAccrualDetailsBulk(record: any): Promise<any> {
  return new Promise((resolve, reject) => {
    let isDataUpdate = false;
    let isStatusApproved = false;

    const accrualStatus =this.accrualStatusDataSource?.find(d => d.id === record.statusMappingId)?.name;

    if (record.oldAmount !== record.accrualAmount) {
      isDataUpdate = true;
    }

    if (
      record.oldStatus !== record.statusMappingId &&
      accrualStatus === "Approved"
    ) {
      isStatusApproved = true;
    }

    const payload = {
      ...record,
      accrualDate: this.datePipe.transform(record.accrualDate, "MM/dd/yyyy"),
      createdBy: this.privilegeService.getLoginUserId(),
    };

    const currencyObj = this.currenciesData.find(
      c => c.id === this.currencyId
    );
    const currency = currencyObj?.name;

    this.financeService.UpdateContractAccrual(payload).subscribe(
      async res => {
        if (!res.status) {
           this.loaderService.hideLoader();
          reject(res);
          return;
        }
         this.loaderService.hideLoader();
        const formattedValue = this.getFormattedValue(
          parseFloat(record.accrualAmount),
          currency
        );

        const accrualMonthYear =
          this.datePipe.transform(record.accrualDate, "MMMM yyyy");

        const navPayload = {
          ContractId: record.contractDetailId,
          currency,
          TabId: ContractTabs.find(t => t.name === TabNames.FINANCE)?.id ?? null,
          SubTabId:
            ContractSubTabs[TabNames.FINANCE]?.find(
              st => st.name === SubTabNames.FINANCE.DRAFT_INVOICE
            )?.id ?? null
        };

        const encoded = encryptUrlParams(navPayload);
        const contractUrl =
          `${environment?._kontractProUrl}/viewcontract?d=${encoded}`;

        const emailPayload: any = {
          SupplierId: this.SupplierId,
          ContractId: record.contractDetailId,
          SponsorId: this.SponsorId,
          EngagementName: this.engagementName,
          AccrualAmount: formattedValue,
          AcrualMonthYear: accrualMonthYear,
          Currency: currency,
          contractLinkHtml: `<a href="${contractUrl}">Link</a>`
        };

        if (isStatusApproved) {
          const approvedDate = record.approvedDateTime  ? new Date(record.approvedDateTime) : new Date();
          await this.notificationService.UpdateAccuralNotification(
            {
              ...emailPayload,
              ApprovedByUser: this.privilegeService.getUserName(record.approvedBy),
              ApprovedDateTime: (approvedDate.getTime() - (5.5 * 60 * 60 * 1000)) // Convert to UTC
            },
            2
          );
        } else if (isDataUpdate) {
          await this.notificationService.UpdateAccuralNotification(
            emailPayload,
            1
          );
        }

        resolve(res);
      },
      err => reject(err)
    );
  });
}



  deleteForecastFile(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._fileService.DeleteFile(this.deleteForecastFiles).subscribe(
        (responseDelete: any) => resolve(responseDelete),
        err => reject(err)
      );
    });
  }
  deleteAccrualFile(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._fileService.DeleteFile(this.deleteAccrualFiles).subscribe(
        (responseDelete: any) => resolve(responseDelete),
        err => reject(err)
      );
    });
  }

  getContractAccrualsByContractId(contractDetail: any) {
    this.financeService.GetContractAccrualByContractId(contractDetail).subscribe(
      response => {
        this._contractAccrualListData = response.data;
        this.loaderService.hideLoader();
        this.tabAndStateService.setDraftInvoicesData(this._contractAccrualListData);
      });
  }
  onSelectionChange() {
     this.selectedTab = Number(this.selectedTab);
      this.isDraftsChanged=false;
   this.isProjecionsChanged=false;
    this.engMonthlyProjectionForm.reset();
    this.engagementFinance = new EngagementFinance();
    this.submitted = false;
    this.isEditMode = false;
    this._contractForecastListData = [];
    this._contractAccrualListData = [];
    this._originalForecastData=[];
    this._originalAccrualsData=[]
    this.displayDraftPopup = false;
    this.displayMonthlyPopup = false;
    this.resetFunction();
    //this.onCancelProjection();
  }

  resetTableData() {
    this._contractForecastListData = [];
    this._contractAccrualListData = [];
  }

  resetMonth() {
    this.engagementFinance.Months = [];
    this.monthDropdownData=[];
    this.resetTableData();
  }

  resetFiscalYear() {
    this.engagementFinance.FiscalYears = null;
    this.fiscalYears = [];
    this.resetMonth();
  }

  resetContract() {
    this.engagementFinance.Contracts = [];
    this.contractdata = [];
    this.resetFiscalYear();
  }

  resetFunction() {
    this.engagementFinance.FunctionIds = [];
    this.functionsData = [];
    this.resetContract();
  }
  uploadedFiles: File[] = [];
  uploadedAccrualFiles: File[] = [];
  _contractAccrualAttachmentsDetails: any[] = [];
  _contractForecastAttachmentsDetails: any[] = [];
  isUploadButtonDisabled: boolean = false;
  multiAccrualFileData: any[] = [];
  multiForecastFileData: any[] = [];
  uploadedAccrualFile: any;
  
attachmentsDetailsMap: { [rowId: string]: any[] } = {};
formDataMap: { [rowId: string]: FormData } = {};

uploadedFilesMap: Map<number, File[]> = new Map(); 
accrualAttachmentsMap: Map<number, AccrualAttachments[]> = new Map();
forecastAttachmentsMap: Map<number, ForecastAttachments[]> = new Map();


onAccrualFileChange(event: any) {
  const files: FileList = event.target.files;
  if (!files || files.length === 0) return;

  if (files.length > 1) {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Select and upload 1 file at a time.',
      detail: ''
    });
    return;
  }

  const uploadedFile = files[0];
  const maxFileSize: number = Number(this._fileService._fileSize); // 20 MB in bytes
  if (uploadedFile.size > maxFileSize) {
    this.messageService.add({
      key: 'tc',
      severity: 'warn',
      summary: 'File Size limited to 20 Mb',
      detail: ''
    });
    return;
  }

  const allowedExtensions: string[] = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx'];
  const extension = (uploadedFile.name.split('.').pop() || '').toLowerCase();
  if (!allowedExtensions.includes(extension)) {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Invalid file type. Only .pdf, .xls, .xlsx, .doc, .docx files are allowed.',
      detail: ''
    });
    return;
  }

  if (this.accrualAttachments.length >= 3) {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Maximum 3 files allowed.',
      detail: ''
    });
    return;
  }

  const timeStamp = formatDate(new Date().toISOString(), this._dateformart.FiletimeStamp, this._dateformart.TimeStampZone);
  const filePath = `/Contracts/Finance/Accrual/${timeStamp}_${uploadedFile.name}`;

  const newAttachment: AccrualAttachments = {
    id: 0,
    fileName: uploadedFile.name,
    filePath: filePath,
    financeContractAccrualId: this.accrualDetail.contractDetailId || 0,
    createdBy: this.userId,
    ceatedDate: new Date(),
    isDeleted: false,
    isPrevFileDelete: false
  };

  this.accrualAttachments.push(newAttachment);

  this.uploadedAccrualFiles.push(uploadedFile);
  this.multiAccrualFileData.push(uploadedFile);
  this.uploadedAccrualFileData.push(uploadedFile);

  this.accrualForm.patchValue({
    _accrualAttachments: this.accrualAttachments.map(a => a.fileName).join(', ')
  });

  this.formData.append('file', uploadedFile, filePath);
  this.isUploadButtonDisabled = this.accrualAttachments.length >= 3;
}

onForecastFileChange(event: any) {

  const files: FileList = event.target.files;
  if (!files || files.length === 0) return;

  if (files.length > 1) {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Select and upload 1 file at a time.',
      detail: ''
    });
    return;
  }

  const uploadedFile = files[0];
  const maxFileSize: number = Number(this._fileService._fileSize); // 20 MB in bytes
  if (uploadedFile.size > maxFileSize) {
    this.messageService.add({
      key: 'tc',
      severity: 'warn',
      summary: 'File Size limited to 20 Mb',
      detail: ''
    });
    return;
  }

  const allowedExtensions: string[] = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx'];
  const extension = (uploadedFile.name.split('.').pop() || '').toLowerCase();
  if (!allowedExtensions.includes(extension)) {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Invalid file type. Only .pdf, .xls, .xlsx, .doc, .docx files are allowed.',
      detail: ''
    });
    return;
  }

  if (this.forecastAttachments.length >= 3) {
    this.messageService.add({
      key: 'tc',
      severity: 'error',
      summary: 'Maximum 3 files allowed.',
      detail: ''
    });
    return;
  }

  const timeStamp = formatDate(new Date().toISOString(), this._dateformart.FiletimeStamp, this._dateformart.TimeStampZone);
  const filePath = `/Contracts/Finance/Forecast/${timeStamp}_${uploadedFile.name}`;

  const newAttachment: ForecastAttachments = {
    id: 0,
    fileName: uploadedFile.name,
    filePath: filePath,
    financeContractForecastId: this.accrualDetail.contractDetailId || 0,
    createdBy: this.userId,
    ceatedDate: new Date(),
    isDeleted: false,
    isPrevFileDelete: false
  };

  this.forecastAttachments.push(newAttachment);
  this.uploadedFiles.push(uploadedFile);
  this.multiForecastFileData.push(uploadedFile);
  this.uploadedForecastFileData.push(uploadedFile);

  this.forecastForm.patchValue({
    _forecastAttachments: this.forecastAttachments.map(a => a.fileName).join(', ')
  });

  this.formData.append('file', uploadedFile, filePath);
  this.isUploadButtonDisabled = this.forecastAttachments.length >= 3;
}

downloadAttachment(data:any)
{
  if(data.name && data.filePath){
   this.downloadFile(data.name, data.filePath);
  }
}


async downloadFile(fileName:any,filePath:any){

var fileDetail = {
  "fileName":fileName,
  "filePath":filePath
};
this._fileService.DownloadFile(fileDetail).subscribe(
  async (res:any)=>{
      var blobData = this._fileService.dataURItoBlob(res);
      if(blobData.size>0){
         var response = await this._fileService.downloadBase64File(blobData,fileDetail.fileName);
         this.loaderService.hideLoader();
      }
      else{
        this.loaderService.hideLoader();
        
      }
  } 
);
}

  deleteUploadedFiles: any[] = [];
  removeAccrualFile(file: File) {
  const uploadedIndex = this.uploadedAccrualFiles.findIndex(f => f.name === file.name);
  if (uploadedIndex !== -1) {
    this.uploadedAccrualFiles.splice(uploadedIndex, 1);
  }

  this.multiAccrualFileData = this.multiAccrualFileData.filter(f => f.name !== file.name);
  this.uploadedAccrualFileData = this.uploadedAccrualFileData.filter(f => f.name !== file.name);

  const attachmentIndex = this.accrualAttachments.findIndex(att => att.fileName === file.name);
  if (attachmentIndex !== -1) {
    const removedAttachment = this.accrualAttachments.splice(attachmentIndex, 1)[0];

    if (removedAttachment.id && removedAttachment.id > 0) {
      this.deleteUploadedFiles.push({
        fileName: removedAttachment.fileName,
        filePath: removedAttachment.filePath
      });
    }
  }

  const globalIndex = this._contractAccrualAttachmentsDetails.findIndex(att => att.FileName === file.name);
  if (globalIndex !== -1) {
    this._contractAccrualAttachmentsDetails.splice(globalIndex, 1);
  }

  this.accrualForm.patchValue({
    _accrualAttachments: this.accrualAttachments.map(a => a.fileName).join(', ')
  });

  this.isUploadButtonDisabled = this.accrualAttachments.length >= 3 ? true : false;
}

  removeForecastFile(file: File) {
  const uploadedIndex = this.uploadedFiles.findIndex(f => f.name === file.name);
  if (uploadedIndex !== -1) {
    this.uploadedFiles.splice(uploadedIndex, 1);
  }

  this.multiForecastFileData = this.multiForecastFileData.filter(f => f.name !== file.name);
  this.uploadedForecastFileData = this.uploadedForecastFileData.filter(f => f.name !== file.name);

  const attachmentIndex = this.forecastAttachments.findIndex(att => att.fileName === file.name);
  if (attachmentIndex !== -1) {
    const removedAttachment = this.forecastAttachments.splice(attachmentIndex, 1)[0];

    if (removedAttachment.id && removedAttachment.id > 0) {
      this.deleteUploadedFiles.push({
        fileName: removedAttachment.fileName,
        filePath: removedAttachment.filePath
      });
    }
  }

  const globalIndex = this._contractForecastAttachmentsDetails.findIndex(att => att.FileName === file.name);
  if (globalIndex !== -1) {
    this._contractForecastAttachmentsDetails.splice(globalIndex, 1);
  }

  this.forecastForm.patchValue({
    _forecastAttachments: this.forecastAttachments.map(a => a.fileName).join(', ')
  });

  this.isUploadButtonDisabled = this.forecastAttachments.length >= 3 ? true : false;
}
  convertKeysToUppercase(obj: any): any {
    const convertedObject: any = {};
  
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const uppercaseKey = key.charAt(0).toUpperCase() + key.slice(1);
            convertedObject[uppercaseKey] = obj[key];
        }
    }
  
    return convertedObject;
  }

    deleteAccrualsAttachment(){
    this._fileService.DeleteFile(this.deleteUploadedFiles).subscribe(
      res => {
      });
    }
isApprovedStatus(rowData: any): boolean {
  const matchFn = (x: any) =>
    x.accrualDate === rowData.accrualDate &&
    x.contractName === rowData.contractName &&
    x.function === rowData.function &&
    x.category === rowData.category;

  const isExists = this.tempEditedRecords.some(matchFn);

  return rowData.accrualStatus === 'Approved' && !isExists;
}


      deleteForecastAttachment(){
    this._fileService.DeleteFile(this.deleteUploadedFiles).subscribe(
      res => {
      });
    }


cancelExportDialog() {
      this.myExportForm.reset();
      this.displayExportPopup=false;
}
  displayExportPopup:boolean=false;
exportexcelKpi(){
this.disablePeriodDropdown=false;
}


}
